<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h5>
            Validate ClientView Account Data with Master Database ({{
              campaignDescription['campaign_name']
            }})
          </h5>
        </vs-col>
        <!-- <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button @click="finished">Finish</vs-button>
        </vs-col> -->
      </vs-row>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <vs-pagination
        :total="total_pages"
        v-model="currentx"
        goto
      ></vs-pagination>

      <template v-for="(matched_account, key) in match_accounts">
        <vs-table stripe :key="key" :data="matched_account" class="mt-10">
          <template slot="thead"> </template>

          <template slot-scope="{ data }">
            <vs-tr>
              <vs-td>
                <vs-button @click="acceptToUpdate(matched_account)"
                  >Update</vs-button
                >
              </vs-td>

              <template
                v-for="(matched, value) in matched_account['master_db_account']"
              >
                <vs-td>
                  <template
                    v-for="field_array_column in selected_account_fields"
                  >
                    <template v-if="field_array_column.id == value">
                      <h6>
                        {{ field_array_column.name }}
                      </h6>
                    </template>
                  </template>

                  <vs-td>
                    <template v-if="Array.isArray(matched)">
                      <template v-for="val1 in matched">
                        {{ val1 }}
                      </template>
                    </template>
                    <template v-else>
                      {{ matched }}
                    </template>
                  </vs-td>
                </vs-td>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </template>
      <vs-pagination
        :total="total_pages"
        v-model="currentx"
        goto
      ></vs-pagination>
    </vx-card>
    <vs-popup
      fullscreen
      style="z-index: 999999"
      class="holamundo"
      title="On the left side you can see the client view data and on the right side the master database accounts. The fields with different values are highlighted in grey."
      :active.sync="enrichAccountDataToMasterDBPopUp"
    >
      <div class="text-center">
        <template
          v-for="(value, key) in accountDataDescription['master_db_account']"
        >
          <vs-col>
            <template v-for="field_array_column in selected_account_fields">
              <template v-if="field_array_column.id == key">
                <div v-if="field_array_column.identifier == 'company_name'">
                  <strong
                    ><span>Account : {{ value }}</span></strong
                  >
                </div>
              </template>
            </template>
          </vs-col>
        </template>
      </div>

      <vs-row vs-w="12" class="mb-10 mt-10">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> Client View Account </u></h6>
            </div>
          </div>
          <template
            v-for="(value, key) in accountDataDescription['csv_account']"
          >
            <vs-col>
              <div
                class="vx-row mb-6"
                v-bind:class="
                  has_different_value.includes(key)
                    ? 'row-height_with_size'
                    : ''
                "
              >
                <div class="vx-col sm:w-1/2 w-full">
                  <template
                    v-for="field_array_column in selected_account_fields"
                  >
                    <template v-if="field_array_column.id == key">
                      <span>{{ field_array_column.name }}  :</span>
                    </template>
                  </template>
                </div>

                <div class="vx-col sm:w-1/2 w-full">
                  <template
                    v-if="has_different_value.includes(key) && value != 'EMPTY'"
                    v-model="accountDataDescription['csv_account'][key]"
                  >
                    <template
                      v-for="field_array_column in selected_account_fields"
                    >
                      <template v-if="field_array_column.id == key">
                        <div
                          v-if="
                            field_array_column.identifier == 'none_core_field'
                          "
                        >
                          <template v-if="Array.isArray(value)">
                            <template v-for="(val1, index1) in value">
                              {{ val1 }}
                            </template>
                          </template>
                          <template v-else>
                            <div
                              v-if="
                                field_array_column.identifier ==
                                  'none_core_field' &&
                                has_different_value.includes(key)
                              "
                            >
                              {{ value }}
                            </div>
                          </template>
                        </div>
                        <template v-else>
                          <div
                            v-if="
                              field_array_column.identifier == 'website' ||
                              field_array_column.identifier == 'linkedin' ||
                              field_array_column.identifier == 'phone' ||
                              field_array_column.identifier == 'switchboard'
                            "
                          >
                            <template v-if="Array.isArray(value)">
                              <template v-for="(val, index) in value">
                                {{ val }}

                                <br />
                              </template>
                            </template>
                            <template v-else>
                               <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                            </template>
                          </div>

                          <div v-else>
                            <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                          </div>
                        </template>

                        <template v-else>
                           <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                        </template>
                      </template>
                    </template>
                  </template>

                  <template v-else>
                    <template
                      v-for="field_array_column in selected_account_fields"
                    >
                      <template v-if="field_array_column.id == key">
                        <div
                          v-if="
                            field_array_column.identifier == 'website' ||
                            field_array_column.identifier == 'linkedin' ||
                            field_array_column.identifier == 'phone' ||
                            field_array_column.identifier == 'switchboard'
                          "
                        >
                          <template v-if="Array.isArray(value)">
                            <template v-for="val1 in value">
                              {{ val1 }}

                              <br />
                            </template>
                          </template>
                          <template v-else>
                            <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                          </template>
                        </div>

                        <template v-else>
                          <div
                            v-if="
                              field_array_column.identifier ==
                                'none_core_field' &&
                              has_different_value.includes(key)
                            "
                          >
                            {{ value }}
                          </div>

                          <div v-else>
                            <template v-if="Array.isArray(value)">
                              <template v-for="val in value">
                                <span class="ml-1">{{ val }} </span>
                              </template>
                            </template>

                            <template v-else>
                               <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                            </template>
                          </div>
                        </template>
                      </template>
                    </template>
                  </template>
                </div>
              </div>
              <vs-divider class="p-5" />
            </vs-col>
          </template>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> Master DB Accounts</u></h6>
            </div>
          </div>
          <template
            v-for="(value, key) in accountDataDescription['master_db_account']"
          >
            <vs-col>
              <div
                class="vx-row mb-6"
                v-bind:class="
                  has_different_value.includes(key)
                    ? 'row-height_with_size'
                    : ''
                "
              >
                <div class="vx-col sm:w-1/3 w-full"></div>
                <template v-for="field_array_column in selected_account_fields">
                  <template v-if="field_array_column.id == key">
                    <div
                                 

                      v-if="
                        field_array_column.identifier == 'website' ||
                        field_array_column.identifier == 'linkedin' ||
                        field_array_column.identifier == 'phone' ||
                        field_array_column.identifier == 'phone_code' ||
                        field_array_column.identifier == 'switchboard' ||
                        field_array_column.identifier ==
                          'switchboard_phone_code'
                      "
                    >

                      <div class="vx-col sm:w-1/2 w-full"  >
                        <template  v-if="has_different_value.includes(key)">


                          <template
                            v-if="
                              field_array_column.identifier == 'switchboard'
                            "
                          >
                            <div class="flex mb-4">
                              <div class="bg-grid-color-secondary h-12 mr-5">
                                <vs-input
                                  class="w-full"
                                  v-model="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ]
                                  "
                                  :name="field_array_column.column_id"
                                  :data-vv-as="field_array_column.column_id"
                                />
                              </div>
                            </div>
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier ==
                              'switchboard_phone_code'
                            "
                          >
                            <div class="flex mb-4">
                              <div class="bg-grid-color-secondary h-12 mr-5">
                                <v-select
                                  label="phone_code"
                                  :options="all_phone_codes"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ]
                                  "
                                />
                              </div>
                            </div>
                          </template>

                          <template
                            v-else-if="field_array_column.identifier == 'phone'"
                          >
                            <div class="flex mb-4">
                              <div class="bg-grid-color-secondary h-12 mr-5">
                                <vs-input
                                  class="w-full"
                                  v-model="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ]
                                  "
                                  :name="field_array_column.column_id"
                                  :data-vv-as="field_array_column.column_id"
                                />
                              </div>
                            </div>
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier == 'phone_code'
                            "
                          >
                            <div class="flex mb-4">
                              <div class="bg-grid-color-secondary h-12 mr-5">
                                <v-select
                                  label="phone_code"
                                  :options="all_phone_codes"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ]
                                  "
                                />
                              </div>
                            </div>
                          </template>

                            <template v-else-if="field_array_column.identifier == 'website'">


                    <template
                    v-for="(w, index) in accountDataDescription['master_db_account'][key]"
                  >

                    <div>
                      <div class=" bg-grid-color-secondary h-12 mr-5">
                        <vs-input
                          name="website_url"
                          v-model="accountDataDescription['master_db_account'][key][index]"
                        />
                      </div>
                   
                    </div>
                  </template>

          
                     
                  </template>

                  <template v-else-if="field_array_column.identifier == 'linkedin'">




                    <template
                    v-for="(w, index) in accountDataDescription['master_db_account'][key]"
                  >


                    <div >
                      <div class="bg-grid-color-secondary h-12 mr-5">
                        <vs-input
                          name="url"
                          v-model="accountDataDescription['master_db_account'][key][index]"
                        />
                      </div>
                   
                    </div>
                  </template>

                
                     
                  </template>



                        </template>

                   

                        <template v-else>
                          <template v-if="Array.isArray(value)">
                            <template v-for="val in value">
                              {{ val }}
                              <br />
                            </template>
                          </template>

                          <template v-else>
                            <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                          </template>
                        </template>
                      </div>
                    </div>

                    <template v-else>
                      <div
                        v-if="
                          field_array_column.identifier == 'none_core_field' &&
                          has_different_value.includes(key)
                        "
                      >
                        <template v-if="Array.isArray(value)">
                          <template v-if="has_different_value.includes(key)">
                            <template
                              v-if="field_array_column.type == 'checkbox'"
                            >
                              <span
                                v-for="(v, v_key) in JSON.parse(
                                  field_array_column.values
                                )"
                                class="p-2"
                              >
                                <input
                                  type="checkbox"
                                  class="mr-2"
                                  :value="v.value"
                                  :id="field_array_column.column_id"
                                  v-model="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ]
                                  "
                                  :checked="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ] != null &&
                                    accountDataDescription['master_db_account'][
                                      key
                                    ].includes(v.value)
                                  "
                                />

                                {{ v.value }}
                              </span>
                            </template>
                          </template>

                          <template v-else>
                            <template v-for="val in value">
                              {{ val }}
                            </template>
                          </template>
                        </template>

                        <template v-else>
                          <template v-if="field_array_column.type == 'number'">
                            <input
                              type="number"
                              class="vs-input-class"
                              v-model="
                                accountDataDescription['master_db_account'][key]
                              "
                              :name="field_array_column.column_id"
                              :data-vv-as="field_array_column.column_id"
                            />
                          </template>

                          <template
                            v-else-if="
                              field_array_column.type == 'text' ||
                              field_array_column.type == 'client_contact'
                            "
                          >
                            <vs-input
                              class="w-full"
                              v-model="
                                accountDataDescription['master_db_account'][key]
                              "
                              :name="field_array_column.column_id"
                              v-validate="
                                field_array_column.mandatory ? 'required' : ''
                              "
                              :data-vv-as="field_array_column.column_id"
                            />
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'date'"
                          >
                            <flat-pickr
                              :config="configDateTimePicker"
                              placeholder="Choose Date"
                              name="audit_date_time"
                              v-model="
                                accountDataDescription['master_db_account'][key]
                              "
                            />
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'datetime'"
                          >
                            <flat-pickr
                              :config="configDateAndTimePicker"
                              placeholder="Choose Date And Time"
                              name="audit_date_and_time"
                              v-model="
                                accountDataDescription['master_db_account'][key]
                              "
                            />
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'choose_one'"
                          >
                            <span
                              v-for="(val, k) in JSON.parse(
                                field_array_column.values
                              )"
                            >
                              <input
                                class="ml-4"
                                :name="key"
                                :value="val.value"
                                type="radio"
                                v-model="
                                  accountDataDescription['master_db_account'][
                                    key
                                  ]
                                "
                              />
                              {{ val.value }}
                            </span>

                            <!-- <v-select
                            label="value"
                            :name="key"
                            :options="JSON.parse(field_array_column.values)"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="accountDataDescription['master_db_account'][key]"
                            v-validate="'required'"
                            data-vv-as="Action Type"
                          /> -->
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'dropdown'"
                          >
                            <v-select
                              label="value"
                              :name="key"
                              :options="JSON.parse(field_array_column.values)"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              v-model="
                                accountDataDescription['master_db_account'][key]
                              "
                              v-validate="'required'"
                              data-vv-as="Action Type"
                            />
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'textarea'"
                          >
                            <vue-trumbowyg
                              v-model="
                                accountDataDescription['master_db_account'][key]
                              "
                              :config="configs.basic"
                            ></vue-trumbowyg>
                          </template>
                        </template>
                      </div>

                      <div v-else>
                        <template v-if="Array.isArray(value)">
                          <template v-if="has_different_value.includes(key)">
                            <template
                              v-if="field_array_column.type == 'checkbox'"
                            >
                              <span
                                v-for="(v, v_key) in JSON.parse(
                                  field_array_column.values
                                )"
                                class="p-2"
                              >
                                <input
                                  type="checkbox"
                                  class="mr-2"
                                  :value="v.value"
                                  :id="field_array_column.column_id"
                                  v-model="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ]
                                  "
                                  :checked="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ] != null &&
                                    accountDataDescription['master_db_account'][
                                      key
                                    ].includes(v.value)
                                  "
                                />

                                {{ v.value }}
                              </span>
                            </template>
                          </template>

                          <template v-else>
                            <template v-for="val in value">
                              {{ val }}
                            </template>
                          </template>
                        </template>

                        <template v-else>
                          <template
                            v-if="
                              has_different_value.includes(key) &&
                              accountDataDescription['master_db_account'][
                                key
                              ] != null
                            "
                          >
                            <template
                              v-if="field_array_column.type == 'number'"
                            >
                              <input
                                type="number"
                                class="vs-input-class"
                                v-model="
                                  accountDataDescription['master_db_account'][
                                    key
                                  ]
                                "
                                :name="field_array_column.column_id"
                                :data-vv-as="field_array_column.column_id"
                              />
                            </template>

                            <template
                              v-else-if="
                                field_array_column.type == 'text' ||
                                field_array_column.type == 'client_contact'
                              "
                            >
                              <template
                                v-if="
                                  field_array_column.identifier !=
                                  'none_core_field'
                                "
                              >
                                <template
                                  v-if="
                                    field_array_column.identifier ==
                                    'registered_office_country'
                                  "
                                >
                                  <v-select
                                    name="registered_office_country"
                                    class="registered_office_country"
                                    label="name_1"
                                    :options="all_countries"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    v-model="
                                      accountDataDescription[
                                        'master_db_account'
                                      ][key]
                                    "
                                  />
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier ==
                                    'head_office_country'
                                  "
                                >
                                  <v-select
                                    name="head_office_country"
                                    class="head_office_country"
                                    label="name_1"
                                    :options="all_countries"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    v-model="
                                      accountDataDescription[
                                        'master_db_account'
                                      ][key]
                                    "
                                  />
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier ==
                                    'registration_jurisdiction'
                                  "
                                >
                                  <v-select
                                    name="registration_jurisdiction"
                                    class="registration_jurisdiction"
                                    label="name_1"
                                    :options="all_countries"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    v-model="
                                      accountDataDescription[
                                        'master_db_account'
                                      ][key]
                                    "
                                  />
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'sic_code'
                                  "
                                >
                                  <div class="vx-col sm:w-1/3 w-full">
                                    <v-select
                                      label="code"
                                      :options="all_sic_codes"
                                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                      v-model="
                                        accountDataDescription[
                                          'master_db_account'
                                        ][key]
                                      "
                                    />
                                  </div>
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'vertical'
                                  "
                                >
                                  <div class="vx-col sm:w-1/3 w-full">
                                    <v-select
                                      label="vertical"
                                      :options="all_verticals"
                                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                      v-model="
                                        accountDataDescription[
                                          'master_db_account'
                                        ][key]
                                      "
                                    />
                                  </div>
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'revenue'
                                  "
                                >
                                  <div class="vx-col sm:w-1/3 w-full">
                                    <input
                                      type="number"
                                      class="vs-input-class"
                                      v-model="
                                        accountDataDescription[
                                          'master_db_account'
                                        ][key]
                                      "
                                      :name="field_array_column.column_id"
                                      :data-vv-as="field_array_column.column_id"
                                    />
                                  </div>
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier ==
                                    'no_of_employees'
                                  "
                                >
                                  <div class="vx-col sm:w-1/3 w-full">
                                    <input
                                      type="number"
                                      class="vs-input-class"
                                      v-model="
                                        accountDataDescription[
                                          'master_db_account'
                                        ][key]
                                      "
                                      :name="field_array_column.column_id"
                                      :data-vv-as="field_array_column.column_id"
                                    />
                                  </div>
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier ==
                                    'currency_code'
                                  "
                                >
                                  <div class="vx-col sm:w-1/3 w-full">
                                    <v-select
                                      label="code"
                                      :options="all_currency_codes"
                                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                      v-model="
                                        accountDataDescription[
                                          'master_db_account'
                                        ][key]
                                      "
                                    />
                                  </div>
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'website'
                                  "
                                >
                                  <template
                                    v-for="(w, index) in accountDataDescription[
                                      'master_db_account'
                                    ][key]"
                                  >
                                    <div class="flex mb-4">
                                      <div
                                        class="bg-grid-color-secondary h-12 mr-5"
                                      >
                                        <vs-input
                                          class="w-full"
                                          name="website_url"
                                          v-validate="'url:require_protocol'"
                                          v-model="
                                            accountDataDescription[
                                              'master_db_account'
                                            ][key][index]['url']
                                          "
                                          data-vv-as="website"
                                        />
                                      </div>
                                      <div class="w-1/5 bg-grid-color h-12">
                                        <vs-icon
                                          class="removeButton"
                                          @click="removeSelectedWeb(key, w)"
                                          color="success"
                                          icon="clear"
                                        >
                                        </vs-icon>
                                      </div>
                                    </div>
                                  </template>

                                  <vs-button
                                    @click="
                                      addWebsite(field_array_column.column_id)
                                    "
                                    color="primary"
                                    type="filled"
                                    >Add</vs-button
                                  >
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'linkedin'
                                  "
                                >
                                  <template
                                    v-for="(w, index) in accountDataDescription[
                                      'master_db_account'
                                    ][key]"
                                  >
                                    <div class="flex mb-4">
                                      <div
                                        class="bg-grid-color-secondary h-12 mr-5"
                                      >
                                        <vs-input
                                          class="w-full"
                                          name="url"
                                          v-validate="'url:require_protocol'"
                                          v-model="
                                            accountDataDescription[
                                              'master_db_account'
                                            ][key][index]['url']
                                          "
                                          data-vv-as="linkedin"
                                        />
                                      </div>
                                      <div class="w-1/5 bg-grid-color h-12">
                                        <vs-icon
                                          class="removeButton"
                                          @click="
                                            removeSelectedLinkedin(key, w)
                                          "
                                          color="success"
                                          icon="clear"
                                        >
                                        </vs-icon>
                                      </div>
                                    </div>
                                  </template>

                                  <vs-button
                                    @click="
                                      addLinkedIn(field_array_column.column_id)
                                    "
                                    color="primary"
                                    type="filled"
                                    >Add</vs-button
                                  >
                                </template>

                                <template v-else>
                                  <vs-input
                                    class="w-full"
                                    v-model="
                                      accountDataDescription[
                                        'master_db_account'
                                      ][key]
                                    "
                                    :name="field_array_column.column_id"
                                    v-validate="
                                      field_array_column.mandatory
                                        ? 'required'
                                        : ''
                                    "
                                    :data-vv-as="field_array_column.column_id"
                                  />
                                </template>
                              </template>

                              <template v-else>
                                <vs-input
                                  class="w-full"
                                  v-model="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ]
                                  "
                                  :name="field_array_column.column_id"
                                  v-validate="
                                    field_array_column.mandatory
                                      ? 'required'
                                      : ''
                                  "
                                  :data-vv-as="field_array_column.column_id"
                                />
                              </template>
                            </template>

                            <template
                              v-else-if="field_array_column.type == 'date'"
                            >
                              <flat-pickr
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="audit_date_time"
                                v-model="
                                  accountDataDescription['master_db_account'][
                                    key
                                  ]
                                "
                              />
                            </template>

                            <template
                              v-else-if="field_array_column.type == 'datetime'"
                            >
                              <flat-pickr
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date And Time"
                                name="audit_date_and_time"
                                v-model="
                                  accountDataDescription['master_db_account'][
                                    key
                                  ]
                                "
                              />
                            </template>

                            <template
                              v-else-if="
                                field_array_column.type == 'choose_one'
                              "
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column.values
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :name="key"
                                  :value="val.value"
                                  type="radio"
                                  v-model="
                                    accountDataDescription['master_db_account'][
                                      key
                                    ]
                                  "
                                />
                                {{ val.value }}
                              </span>

                              <!-- <v-select
                            label="value"
                            :name="key"
                            :options="JSON.parse(field_array_column.values)"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="accountDataDescription['master_db_account'][key]"
                            v-validate="'required'"
                            data-vv-as="Action Type"
                          /> -->
                            </template>

                            <template
                              v-else-if="field_array_column.type == 'dropdown'"
                            >
                              <v-select
                                label="value"
                                :name="key"
                                :options="JSON.parse(field_array_column.values)"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                v-model="
                                  accountDataDescription['master_db_account'][
                                    key
                                  ]
                                "
                                v-validate="'required'"
                                data-vv-as="Action Type"
                              />
                            </template>

                            <template
                              v-else-if="field_array_column.type == 'textarea'"
                            >
                              <vue-trumbowyg
                                v-model="
                                  accountDataDescription['master_db_account'][
                                    key
                                  ]
                                "
                                :config="configs.basic"
                              ></vue-trumbowyg>
                            </template>
                          </template>

                          <template v-else>
                            <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                          </template>

                          <!-- {{ value }}   -->
                        </template>
                      </div>
                    </template>
                  </template>
                </template>
              </div>
              <vs-divider class="p-5" />
            </vs-col>
          </template>
        </vs-col>
      </vs-row>

           <div class="text-center">
                <vs-button class="m-10"  @click.prevent="ignoreMasterDBAccountFromValidateClientView">Ignore</vs-button>


                <vs-button  @click.prevent="submitForm">Submit</vs-button>
      </div>
    </vs-popup>

    <vs-popup
      title="Imported Excel Data To Master Database"
      style="z-index: 999999"
      class="holamundo"
      :active.sync="importExcelDataToMasterDatabasePopUp"
      :button-close-hidden="true"
      @close="closeimportExcelDataToMasterDatabasePopUp"
    >
      <vs-row class="p-2">
        <vs-col vs-type="flex" vs-w="3">
          <vs-col vs-type="flex" vs-w="12">
            <u><h5>Matched</h5></u>
          </vs-col>
        </vs-col>

        <vs-col vs-type="flex" vs-w="3">
          <vs-col vs-type="flex" vs-w="12">
            <u><h5>Count</h5></u>
          </vs-col>
        </vs-col>
      </vs-row>

      <template v-for="(value, key) in count_matched_accounts">
        <vs-row class="p-2">
          <vs-col vs-type="flex" vs-w="3">
            <vs-col vs-type="flex" vs-w="12">
              {{ value['added_through'] }}
            </vs-col>
          </vs-col>

          <vs-col vs-type="flex" vs-w="3">
            <vs-col vs-type="flex" vs-w="12">
              {{ value['count'] }}
            </vs-col>
          </vs-col>
        </vs-row>
      </template>

      <div class="text-center mt-5">
        <vs-button @click="finished">Finish</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import DataGrid from '@/components/aggrid/Aggrid.vue'
import defineAbilitiesFor from '@/config/abilities'
import axios from '@/axios.js'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import VueTrumbowyg  from 'vue-trumbowyg';
import 'jquery-resizable-dom/dist/jquery-resizable.js';
import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js';

import 'trumbowyg/dist/trumbowyg.min.js';
import 'trumbowyg/dist/ui/trumbowyg.min.css';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js';
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'
export default {
  data: () => ({
       configs: {
          basic: {
            autogrow: true,
            removeformatPasted: true,
                btns: [
                    ['strong', 'em'],
                    ['superscript', 'subscript'],
                    ['fontsize'],
                    ['foreColor', 'backColor'],
                    ['link'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['fullscreen']
                ],
                plugins: {
                    table: {
                        columns: 10,
                        rows: 10,
                    
                    },
                    resizimg: {
            minSize: 64,
            step: 16,
        }

                    }
                        }
      },
    all_currency_codes: [],
    all_verticals: [],
    all_sic_codes: [],
    all_countries: [],
    count_matched_accounts: [],
    importExcelDataToMasterDatabasePopUp: false,
    closeimportExcelDataToMasterDatabasePopUp: false,
    campaignName: null,
    has_different_value: [],
    configDateTimePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d'
    },
    configDateAndTimePicker: {
      enableTime: true,
      dateFormat: 'Y-m-d H:i:s',
      enableSeconds: true
    },
    review_changes: [],
    match_accounts: [],
    total_pages: 0,
    limit: 10,
    currentx: 1,
    paginate: { limit: 10, offset: 0 },
    accounts: {
      master_phone: [],
      master_switchboard: [],
      site_switchboard: [],
      master_site_switchboard: null,
      company_name: null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      head_office_country: null,
      company_registration_number: null,
      registration_jurisdiction: null,
      status: null,
      parent: null,
      web: [],
      master_web: null,
      master_linkedin: null,
      phone: null,
      linkedin: [],
      country: null,
      revenue: null,
      no_of_employees: null
    },
    accountDataDescription: {},
    enrichAccountDataToMasterDBPopUp: false,
    enrichOtherFieldAccountDataToMasterDBPopUp: false,
    abilities: null,
    table_name: null,
    log: [],
    dataSource: {},
    campaignDescription: [],
    enrichAccountDataToMasterDB: [],
    selected_account_fields: [],
    updated_account_description: []
  }),
  components: {
    'v-select': vSelect,
    DataGrid,
    flatPickr,
        VueTrumbowyg
  },
  watch: {
    currentx: function (val, oldVal) {
      this.paginate = { limit: 10, offset: (val - 1) * this.limit }
      this.ValidateClientViewAccountDataWithMasterDBView()
    }
  },
  methods: {
    submitForm () {
      let new_data = {}

      let self = this
      this.$vs.loading()

      for (let key in this.accountDataDescription['master_db_account']) {
        if (this.accountDataDescription['has_different_value'].includes(key)) {
          if (
            this.accountDataDescription['master_db_account'][key] == 'EMPTY'
          ) {
            this.accountDataDescription['master_db_account'][key] = null
          }

          new_data[key] = this.accountDataDescription['master_db_account'][key]
        }
      }

      new_data['campaignId'] = this.campaignId
      new_data['account_id'] = this.accountDataDescription['account_id']
      new_data['id'] = this.accountDataDescription['id']

      console.log('new_data', new_data)
      // return false

      this.$store
        .dispatch(
          'accountsManagement/updateMasterDBAccountFromClientView',
          new_data
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'Account Updated',
              text: 'The account was enriched successfully.'
            })
            // this.matchedData()

            // self.enrichAccountDataToMasterDBPopUp = false
            location.reload()

            // this.matchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    removeDuplicates (arr) {
      let unique = arr.reduce(function (acc, curr) {
        if (!acc.includes(curr)) acc.push(curr)
        return acc
      }, [])
      return unique
    },
    toggleConfirmedStatus (val, toggle, key) {
      console.log(val)
      console.log(toggle)
      console.log(key)

      if (Array.isArray(this.updated_account_description[key])) {
        if (toggle == true) {
          this.updated_account_description[key].push(val)
        } else {
          this.updated_account_description[key] =
            this.updated_account_description[key].filter(function (
              value,
              index,
              arr
            ) {
              return value != val
            })
        }

        // this.updated_account_description[key] = this.removeDuplicates(this.updated_account_description[key])

        console.log(
          'updated_account_description',
          this.updated_account_description[key]
        )
      } else {
        if (toggle == true) {
          this.updated_account_description[key] = val
        } else {
          this.updated_account_description[key] = null
        }
      }

      console.log(
        'updated_account_description',
        this.updated_account_description[key]
      )
    },

    acceptToUpdate (data) {
      this.accountDataDescription = data

      this.updated_account_description = data['updated_csv']

      this.has_different_value =
        this.accountDataDescription['has_different_value']

      for (let key in this.accountDataDescription['csv_account']) {
        if (
          this.accountDataDescription['csv_account'][key] == null ||
          this.accountDataDescription['csv_account'][key] == ''
        ) {
          this.accountDataDescription['csv_account'][key] = 'EMPTY'
        }

        // if (Array.isArray( this.accountDataDescription['csv_account'][key])){
        //     this.accountDataDescription['csv_account'][key] = this.removeDuplicates(this.accountDataDescription['csv_account'][key])

        //   }
      }

      for (let key in this.accountDataDescription['master_db_account']) {
        if (
          this.accountDataDescription['master_db_account'][key] == null ||
          this.accountDataDescription['master_db_account'][key] == ''
        ) {
          this.accountDataDescription['master_db_account'][key] = 'EMPTY'
        }

        // if (Array.isArray( this.accountDataDescription['master_db_account'][key])){
        //   this.accountDataDescription['master_db_account'][key] = this.removeDuplicates(this.accountDataDescription['master_db_account'][key])

        // }
      }

      this.enrichAccountDataToMasterDBPopUp = true
    },
    finished () {
      this.importExcelDataToMasterDatabasePopUp = false

      this.$router
        .push('/accounts/compareNewExcelDataToMasterDb/' + this.campaignId)
        .catch(() => {})

      // this.$router
      //   .push("/accounts/matched/" + this.campaignId + '/' + btoa(this.campaignName))
      //   .catch(() => { });
    },
 ignoreMasterDBAccountFromValidateClientView () {
      let self = this


      let formData = {}
      formData.account_id = this.accountDataDescription.account_id
      formData.campaignId = this.campaignId

      this.$store
        .dispatch('accountsManagement/ignoreMasterDBAccountFromValidateClientView', formData)
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'Account Ignored',
              text: 'This account has been ignored.'
            })
            this.$router.go()
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    goBack: function () {
      this.$router.go(-1)
    },
    formatUploadedHeader (s) {
      if (typeof s !== 'string') return ''
      if (s.startsWith('ml_')) return ''
      if (s === 'master_db_account') return ''
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s
    },
    ValidateClientViewAccountDataWithMasterDBView () {
      let self = this
      this.$vs.loading()
      this.paginate.campaignId = this.campaignId
      axios
        .post(
          this.$base_url + '/api/campaigns/validate_client_view_account_data_with_master_db_view',
          this.paginate
        )
        .then(response => {
          this.match_accounts = JSON.parse(response.data).rows

          if (this.match_accounts.length != 0) {
            this.selected_account_fields = JSON.parse(
              response.data
            ).client_view_account_table_name_data

            let total = JSON.parse(response.data).total_pages
            this.total_pages = Math.ceil(total / this.limit)
            this.$vs.loading.close()
            console.log(this.match_accounts)
          } else {


            self.$vs.loading.close()

            // self.$router
            //   .push(
            //     '/accounts/matched/' +
            //       self.$route.params.campaignId +
            //       '/' +
            //       btoa(self.campaignName)
            //   )
            //   .catch(() => {})

           
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getImportedExcelDataToMasterDBRecords () {
      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId
      this.$store
        .dispatch(
          'campaignsManagement/getImportedExcelDataToMasterDBRecords',
          data
        )
        .then(res => {
          self.count_matched_accounts = JSON.parse(res.data)

          self.importExcelDataToMasterDatabasePopUp = true

          // console.log(self.count_matched_accounts);
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },

    getCampaignDescription () {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDescription = res.data
          this.campaignName = this.campaignDescription.campaign_name
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },
    getPhoneTypes () {
      this.$store
        .dispatch('accountsManagement/getPhoneTypes')
        .then(res => {
          this.phoneTypes = res.data
          this.phoneTypes = this.phoneTypes.filter(
            item =>
              item.slug != 'head_office_switchboard' &&
              item.slug != 'site_switchboard'
          )
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getAllPhoneCodes () {
      let self = this
      this.$store
        .dispatch('accountsManagement/getAllPhoneCodes')
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getAllSicCodes () {
      this.$store
        .dispatch('accountsManagement/getAllSicCodes')
        .then(response => {
          let data = response.data
          this.all_sic_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getAllVerticals () {
      this.$store
        .dispatch('accountsManagement/getAllVerticals')
        .then(response => {
          let data = response.data
          this.all_verticals = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getAllCurrencyCodes () {
      this.$store
        .dispatch('accountsManagement/getAllCurrencyCodes')
        .then(response => {
          let data = response.data
          this.all_currency_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    }
  },
  mounted () {
    this.getCampaignDescription()
    this.ValidateClientViewAccountDataWithMasterDBView()

    this.getPhoneTypes()
    this.getAllPhoneCodes()
    this.getAllSicCodes()
    this.getAllVerticals()
    this.getAllCurrencyCodes()
  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }
    this.campaignId = this.$route.params.campaignId

    // this.getAssocaitedAccountsAccounts();
  }
}
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.width_class {
  width: 580px;
}

.imput_field {
  width: 500px;
}

textarea{
  display: none;
}

.accept-button {
  cursor: pointer;
}

.row-height_with_size {
  height: 70px !important;
  background-color: #f5f5f5 !important;
  padding: 15px;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.vs-input-class{
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all .2s ease;


}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
